import React from "react"
import styled from "styled-components"
import Quote from "./Quote"

const Testimonials = props => {
  const { testimonials } = props

  return (
    <Container>
      {!!testimonials &&
        testimonials.map(({ ...quote }, index) => {
          return <Quote key={index} {...quote} />
        })}
    </Container>
  )
}

export default Testimonials

const Container = styled.div`
  justify-content: center;
  align-items: center;
  @media (min-width: 1050px) {
    padding: 0 45px;
  }
  @media (min-width: 800px) {
    margin-bottom: 50px;
  }
  margin-bottom: 30px;
  flex-direction: column;
  display: flex;
  padding: 0 5%;
`
